/**
 * Stub for web
 */
export const useUpdateDevice = () => {
  return [() => Promise.resolve(), {}];
};
